import * as React from 'react';
import * as style from './styles.scss';
import { Info1SVG } from 'assets/svg';
import { AccountDropdown, Fallback } from 'components/common';
import { AccountType, SystemType } from 'constants/enum';
import { IState } from 'redux/global-reducers';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { formatNumber, handleError } from 'utils/common';
import { prefixAccount } from '../../utils';
import { withErrorBoundary } from 'react-error-boundary';
import { IEquityTransferableAmountResponse } from 'interfaces/api';

export interface ISendingAccountProps
  extends React.ClassAttributes<SendingAccountComponent>,
    WithNamespaces {
  readonly selectedAccount: IState['selectedAccount'];
  readonly equityCashAdvancedAmount: IState['equityCashAdvancedAmount'];
  readonly equityTransferableAmount: IState['equityTransferableAmount'];
  readonly userInfo: IState['userInfo'];
  readonly transferAmount?: number;
  readonly isVSD?: boolean;
  readonly isWithdrawVSD?: boolean;
  readonly isTransferToBank?: boolean;
  readonly accountList: IState['accountList'];

  readonly accountBalance?: IEquityTransferableAmountResponse;
}

interface ISendingAccountState {
  readonly isHover: boolean;
}

class SendingAccountComponent extends React.Component<
  ISendingAccountProps,
  ISendingAccountState
> {
  constructor(props: ISendingAccountProps) {
    super(props);
    this.state = {
      isHover: false,
    };
  }

  render() {
    const {
      t,
      equityCashAdvancedAmount,
      equityTransferableAmount,
    } = this.props;
    return (
      <div className={style.SendingAccountNew}>
        <div className={style.SendingAccountTitle}>
          <p>{t('Sending Acc.Info')}</p>
        </div>
        <div className={style.SendingAccountContent}>
          <div className={style.SendingAccountRight}>
            <div>
              <p>{t('Source Account')}</p>
              <div className={style.SendingAccountDropdown}>
                {this.props.isVSD ? (
                  this.props.isWithdrawVSD ? (
                    <p>{prefixAccount() + this.props.userInfo?.username}</p>
                  ) : (
                    <p>{this.props.selectedAccount?.account}</p>
                  )
                ) : (
                  <AccountDropdown
                    isForm={true}
                    unshowAccounts={this.props.accountList
                      .filter(
                        (account) =>
                          account.accountType === AccountType.EQUITY &&
                          account.isIICA
                      )
                      .map((acc) => acc.account)}
                  />
                )}
              </div>
            </div>
            {this.props.selectedAccount?.type === SystemType.EQUITY ? (
              <>
                <div>
                  <div className={style.SendingAccountTooltipWrapper}>
                    <span
                      className={style.SendingAccountTooltip}
                      style={{
                        display: this.state.isHover ? 'flex' : 'none',
                      }}
                    >
                    {this.props.selectedAccount?.accountType === AccountType.MARGIN ? t('Available Balance Formula M') : t('Available Balance Formula')}
                    </span>
                    <p>{t('Available Balance')}</p>
                    <div
                      onMouseEnter={() => this.onHover(true)}
                      onMouseLeave={() => this.onHover(false)}
                    >
                      <span className={style.IconInfo}>
                        <Info1SVG />
                      </span>
                    </div>
                  </div>
                  <p className={style.SendingAccountTextBox}>
                    {formatNumber(
                      equityTransferableAmount.data?.transferableAmount ?? 0
                    )}{' '}
                    VNĐ
                  </p>
                </div>
                <div>
                  <p>{t('Settled Balance')}</p>
                  <p className={style.SendingAccountTextBox}>
                    {formatNumber(
                      equityTransferableAmount.data?.mvBalance ?? 0
                    )}{' '}
                    VNĐ
                  </p>
                </div>
                <div>
                  <p>{t('Amount Available')}</p>
                  <p className={style.SendingAccountTextBox}>
                    {formatNumber(
                      equityCashAdvancedAmount.data?.availableCashAdvance
                    )}{' '}
                    VNĐ
                  </p>
                </div>
              </>
            ) : (
              <>
                <div>
                  <p>{t('Full name')}</p>
                  <p className={style.SendingAccountTextBox}>
                    {this.props.selectedAccount?.accountName}
                  </p>
                </div>
                <div>
                  <p>{t('Transferable Amount')}</p>
                  <p className={style.SendingAccountTextBox}>
                    {formatNumber(this.props.transferAmount)} VNĐ
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  private onHover = (isHover: boolean) => {
    this.setState({ isHover });
  };
}

const mapStateToProps = (state: IState) => ({
  selectedAccount: state.selectedAccount,
  userInfo: state.userInfo,
  accountList: state.accountList,
  equityCashAdvancedAmount: state.equityCashAdvancedAmount,
  equityTransferableAmount: state.equityTransferableAmount,
});

const SendingAccount = withErrorBoundary(
  withNamespaces('common')(connect(mapStateToProps)(SendingAccountComponent)),
  Fallback,
  handleError
);

export default SendingAccount;



// WEBPACK FOOTER //
// ./src/components/areas/Account/CashTransfer1/Common/SendingAccountNew/index.tsx